import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=4524ca1e&scoped=true&"
import script from "./Booking.vue?vue&type=script&lang=js&"
export * from "./Booking.vue?vue&type=script&lang=js&"
import style0 from "./Booking.vue?vue&type=style&index=0&id=4524ca1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524ca1e",
  null
  
)

export default component.exports